export const SET_ORDER_COMMENT = 'purchase/SET_ORDER_COMMENT';

export const SET_TIP_PERCENT = 'purchase/SET_TIP_PERCENT';

export const SET_PAYMENT_TYPE = 'purchase/SET_PAYMENT_TYPE';

export const SET_USE_CASH_POINTS = 'purchase/SET_USE_CASH_POINTS';

export const PLACE_ORDER = 'purchase/PLACE_ORDER';

export const INC_CUTLERY = 'purchase/INC_CUTLERY';
export const DEC_CUTLERY = 'purchase/DEC_CUTLERY';
